import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import './ResourcesDetail.scss';

const ResourcesDetail = ( { data } ) => {
  const { links, files } = data;
  return (
    <div className="resourcesDetail">

      { links && links.length > 0 && (

        <div className="resourcesDetail-row">
          <h2>Links</h2>
          <ul>
            {links.map( ( link, index ) => (
              <li key={index}>
                <Link className="resourcesDetail-row__item" to={{ pathname: link.uri }} target="_blank">
                  {link.title}
                </Link>
              </li>
            ) )}
          </ul>
        </div>

      )}

      { files && files.length > 0 && (

        <div className="resourcesDetail-row">
          <h2>Documents</h2>
          <ul>
            {files.map( ( file, index ) => (
              <li key={index}>
                { file.path ? (
                  <Link className="resourcesDetail-row__item" to={{ pathname: file.path }} target="_blank">
                    {file.name}
                  </Link>
                ) : (
                  <span className="resourcesDetail-row__item resourcesDetail-row__item--loading">
                    {file.name}
                  </span>
                )}
              </li>
            ) )}
          </ul>
        </div>
      )}

    </div>
  );
};

ResourcesDetail.propTypes = {
  data: PropTypes.object,
};

ResourcesDetail.defaultProps = {
  data: {
    links: [],
    files: [],
  },
}

export default ResourcesDetail;
